import { isEmpty, map, sortBy } from 'lodash';
import { createSelector } from 'reselect';

export const profileData = state => state.getIn(['homeProfile', 'profileData']);
export const profileDataError = state => state.getIn(['homeProfile', 'profileDataError']);
export const profileDataIsLoading = state => state.getIn(['homeProfile', 'profileDataIsLoading']);

// TODO: Remove .toJS() from this file
// WARNING: It is not best practice to use .toJS() here! Please do not copy this pattern.

export const address = state => {
  const addr = state.getIn(['homeProfile', 'profileData', 'address']);
  return isEmpty(addr) ? {} : addr.toJS();
};

export const hasLead = state => state.getIn(['homeProfile', 'profileData', 'has_lead']);

export const comps = state => {
  const c = state.getIn(['homeProfile', 'profileData', 'comps']);
  return isEmpty(c) ? {} : c.toJS();
};

export const homeDetails = state => {
  const details = state.getIn(['homeProfile', 'profileData', 'home_details']);
  return isEmpty(details) ? {} : details.toJS();
};

export const changedCoreAnswers = state => {
  const details = state.getIn(['homeProfile', 'profileData', 'changed_core_answers']);
  return isEmpty(details) ? {} : details.toJS();
};

export const valuation = state => {
  const val = state.getIn(['homeProfile', 'profileData', 'valuation']);
  return isEmpty(val) ? {} : val.toJS();
};

export const marketIdentifier = state => state.getIn(['homeProfile', 'marketIdentifier']);

// Used to plot the trend lines of market vs zip
export const marketTrends = state => {
  const trends = state.getIn(['homeProfile', 'marketTrends']);
  return isEmpty(trends) ? {} : trends.toJS();
};

// Used to look at market stats like DOM, median price, etc.
export const marketStats = state => {
  const data = state.getIn(['homeProfile', 'profileData', 'market_data']);
  return isEmpty(data) ? {} : data.toJS();
};

// Used to fetch OD's market-specific brokerage information like name, address, license number, etc.
export const brokerageInfo = state => {
  const brokerageInfo = state.getIn(['homeProfile', 'brokerageInfo']);
  return isEmpty(brokerageInfo) ? {} : brokerageInfo.toJS(); // Sorry :(
};

export const getSortedComps = () => createSelector(comps, c => sortBy(c, 'listing_details.price'));

export const getProcessedMarketTrends = () =>
  createSelector(marketTrends, marketTrends => {
    if (isEmpty(marketTrends)) {
      return {};
    }
    const market = map(marketTrends.market, point => ({ date: point[0], price: point[1] }));
    const zipCode = map(marketTrends.zipCode, point => ({ date: point[0], price: point[1] }));
    return { market, zipCode };
  });
